import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {},
}));

/**
 * Refinitiv Branding
 *
 * Props:
 ** className: name of css class element
 */
const RefinitivBrand = (props) => {
  const { children, className, ...rest } = props;
  const classes = useStyles();

  return (
    <Typography {...rest} className={clsx(classes.root, className)}>
      Powered by Refinitiv World-Check One
    </Typography>
  );
};

export default RefinitivBrand;
